import axios from "axios";
import React, { useState } from "react";
import { FaEdit } from "react-icons/fa";
import { toast } from "react-toastify";
import { useGetCategoryQuery } from "../../../features/api/categoryApi";

import { useGetProductQuery } from "../../../features/api/productApi";
import { useEditModelMutation } from "../../../features/api/modelApi";
import { useGetSubCategoryQuery } from "../../../features/api/subcategoryApi";

const UpdateSubItemList = ({ productModel }) => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };

  const [cat_id, setCat_id] = useState(0);
  const [subCat_id, setSubCat_id] = useState(0);
  const [product_id, setProduct_id] = useState(0);
  const [model, setModel] = useState("");

  const { data } = useGetCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const categories = data?.categories;

  const subCategory = useGetSubCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.brandData;

  const products = useGetProductQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.data;

  const filterSubCat = subCategory?.filter((item) => item?.cat_name == cat_id);
  const filterProduct = products?.filter(
    (item) => item?.sub_catName == subCat_id
  );

  const [editModel] = useEditModelMutation();
  const handleUpdate = async () => {
    try {
      const newProductModel = {
        id: productModel?.model_id,
        model_name: model || productModel.model_name,
        category_id: +cat_id || productModel.category_id,
        subcategory_id: +subCat_id || productModel.subcategory_id,
        product_id: +product_id || productModel.product_id,
      };
      const response = await editModel(newProductModel);
      if (!response?.error) {
        setIsOpen(false);
        document.body.style.overflow = "auto";
        toast.success("updated successfully...!!!");
      } else {
        toast.error(response?.error?.data?.error);
      }
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };

  return (
    <div>
      <span onClick={openModal}>
        <FaEdit className="text-xl text-blue-500 font-bold cursor-pointer" />
      </span>

      {isOpen && (
        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-slate-200 p-6 rounded shadow-md lg:w-[500px]">
            <button
              className="text-red-500 font-bold float-right"
              onClick={closeModal}
            >
              X
            </button>
            <div className="card bg-base-100 overflow-auto mt-4">
              <div className="card-body">
                <div
                  className="flex flex-col items-start font-extralight p-4"
                  style={{ lineHeight: "30px" }}
                >
                  <div className="flex flex-col gap-4 w-full">
                    <div className="w-full">
                      <input
                        type="text"
                        value={productModel?.category}
                        disabled
                        className="border pl-1 w-[50%] h-8 bg-slate-50"
                      />
                      <select
                        onChange={(e) => setCat_id(Number(e.target.value))}
                        className="border pl-1 h-8 bg-slate-50 w-[50%]"
                      >
                        <option>--Select Category--</option>
                        {categories?.map((category) => (
                          <option key={category?.id} value={category?.id}>
                            {category?.cat_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="w-full">
                      <input
                        type="text"
                        value={productModel?.subCategory}
                        disabled
                        className="border pl-1 w-[50%] h-8 bg-slate-50"
                      />
                      <select
                        onChange={(e) => setSubCat_id(Number(e.target.value))}
                        className="border pl-1 h-8 bg-slate-50 w-[50%]"
                      >
                        <option>--Select Brand--</option>
                        {filterSubCat?.map((category) => (
                          <option key={category?.id} value={category?.id}>
                            {category?.sub_catName}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="w-full">
                      <input
                        type="text"
                        value={productModel?.product}
                        disabled
                        className="border pl-1 w-[50%] h-8 bg-slate-50"
                      />
                      <select
                        onChange={(e) => setProduct_id(Number(e.target.value))}
                        className="border pl-1 h-8 bg-slate-50 w-[50%]"
                      >
                        <option>--Select Product--</option>
                        {filterProduct?.map((product) => (
                          <option key={product?.id} value={product?.id}>
                            {product?.product_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <input
                      type="text"
                      defaultValue={productModel?.model_name}
                      onChange={(e) => setModel(e.target.value)}
                      className="border pl-1 h-8 bg-slate-50"
                      placeholder="Enter Model Name..."
                    />
                  </div>
                  <button
                    onClick={() => handleUpdate()}
                    className="bg-blue-500 text-white font-bold mt-4 px-2 rounded block m-auto"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateSubItemList;
